export enum TabsToggleSize {
  XSMALL = 'XSMALL',
  SMALL = 'SMALL',
  MEDIUM = 'medium',
}

export enum TabToggleVariant {
  LIGHT = 'LIGHT',
  DEFAULT = 'DEFAULT',
}

export interface TabToggleData {
  id: string;
  text: string;
}
